import qs, { ParsedQs } from 'qs';
import { useLocation } from 'react-router-dom';

export const useSearchParams = <T extends ParsedQs>(): T => {
  const { search } = useLocation();

  return qs.parse(search?.replace(/^\?/, '')) as T;
};
